/*!
 * froala_editor v3.0.6 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2019 Froala Labs
 */
!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(require("froala-editor")) : "function" == typeof define && define.amd ? define(["froala-editor"], e) : e(t.FroalaEditor);
}(this, function (t) {
  "use strict";

  function l(t) {
    return (l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }

  if (t = t && t.hasOwnProperty("default") ? t["default"] : t, Object.assign(t.DEFAULTS, {
    imageTUIOptions: {
      includeUI: {
        theme: {
          "menu.normalIcon.path": "https://cdn.jsdelivr.net/npm/tui-image-editor@3.2.2/dist/svg/icon-d.svg",
          "menu.activeIcon.path": "https://cdn.jsdelivr.net/npm/tui-image-editor@3.2.2/dist/svg/icon-b.svg",
          "menu.disabledIcon.path": "https://cdn.jsdelivr.net/npm/tui-image-editor@3.2.2/dist/svg/icon-a.svg",
          "menu.hoverIcon.path": "https://cdn.jsdelivr.net/npm/tui-image-editor@3.2.2/dist/svg/icon-c.svg",
          "submenu.normalIcon.path": "https://cdn.jsdelivr.net/npm/tui-image-editor@3.2.2/dist/svg/icon-d.svg",
          "submenu.normalIcon.name": "icon-d",
          "submenu.activeIcon.path": "https://cdn.jsdelivr.net/npm/tui-image-editor@3.2.2/dist/svg/icon-c.svg",
          "submenu.activeIcon.name": "icon-c"
        },
        initMenu: "filter",
        menuBarPosition: "left"
      }
    },
    tui: window.tui
  }), t.PLUGINS.imageTUI = function (r) {
    var s = r.$;

    function c(t) {
      s("#tuieditor").remove(), t.style.display = "none";
    }

    return {
      _init: function i() {
        var t = r.o_doc.body,
            e = r.o_doc.createElement("div");
        e.setAttribute("id", "tuiContainer"), e.style.cssText = "position: fixed; top: 0;left: 0;margin: 0;padding: 0;width: 100%;height: 100%;background: rgba(0,0,0,.5);z-index: 9998;display:none", t.appendChild(e);
      },
      launch: function u(e) {
        if ("object" === l(r.opts.tui)) {
          var t = r.o_doc.createElement("div");
          t.setAttribute("id", "tuieditor");
          var i = r.o_doc.getElementById("tuiContainer");
          i.appendChild(t), i.style.display = "block";
          var n = e.image.get(),
              o = r.opts.imageTUIOptions;
          o.includeUI.loadImage = {
            path: n[0].src,
            name: " "
          };
          var a = new r.opts.tui.ImageEditor(r.o_doc.querySelector("#tuieditor"), o),
              d = r.o_doc.getElementById("tuieditor");
          d.style.minHeight = "590px", d.style.width = "94%", d.style.height = "94%", d.style.margin = "auto", s(".tui-image-editor-header-buttons").html('<button class="tui-editor-cancel-btn" data-cmd="cancel_tui_image">Cancel</button> <button class="tui-editor-save-btn">Save</button>'), s(".tui-editor-cancel-btn")[0].addEventListener("click", function (t) {
            c(i);
          }), s(".tui-editor-save-btn")[0].addEventListener("click", function (t) {
            !function s(t, e, i) {
              for (var n = t.toDataURL(), o = atob(n.split(",")[1]), a = [], d = 0; d < o.length; d++) {
                a.push(o.charCodeAt(d));
              }

              var r = new Blob([new Uint8Array(a)], {
                type: "image/png"
              });
              e.image.edit(i), e.image.upload([r]);
            }(a, e, n), c(i);
          });
        }
      }
    };
  }, t.DefineIcon("imageTUI", {
    NAME: "sliders",
    FA5NAME: "sliders-h",
    SVG_KEY: "advancedImageEditor"
  }), t.RegisterCommand("imageTUI", {
    title: "Advanced Edit",
    undo: !1,
    focus: !1,
    callback: function callback(t, e) {
      this.imageTUI.launch(this);
    },
    plugin: "imageTUI"
  }), !t.PLUGINS.image) throw new Error("TUI image editor plugin requires image plugin.");
  t.DEFAULTS.imageEditButtons.push("imageTUI");
});